import { ShareOfVoicePrompt } from '@/common/model/media/shareOfVoice'

import Badge, { BadgeType } from '@/components/view/atoms/badge/Badge'
import TableHeadItem from '@/components/view/atoms/table/TableHeadItem'
import TableRow from '@/components/view/atoms/table/TableRow'
import TableRowItem from '@/components/view/atoms/table/TableRowItem'
import Text, { TextColor } from '@/components/view/atoms/text/Text'

import GeoSection from '@/components/container/modules/mediaGeo/common/GeoSection'

interface Props {
  prompts: ShareOfVoicePrompt[]
  // 自社ブランド名。言及ブランドのバッジを強調表示する
  ownBrand?: string
}

// 各質問に対するAI回答で言及されたブランドの一覧テーブル
const ShareOfVoicePromptTable = ({ prompts, ownBrand }: Props) => (
  <GeoSection
    title='プロンプト別結果'
    subText='各質問に対するAI回答で言及されたブランド（カテゴリからAIが10〜15問を都度生成）'
    noPadding
  >
    <table className='border-secondary w-full'>
      <thead>
        <TableRow head>
          <TableHeadItem type='thin' width={320}>
            <Text size={12} color={TextColor.SECONDARY}>
              質問内容
            </Text>
          </TableHeadItem>
          <TableHeadItem type='thin' width={88}>
            <Text size={12} color={TextColor.SECONDARY}>
              言及ブランド数
            </Text>
          </TableHeadItem>
          <TableHeadItem type='thin'>
            <Text size={12} color={TextColor.SECONDARY}>
              言及ブランド
            </Text>
          </TableHeadItem>
        </TableRow>
      </thead>
      <tbody>
        {prompts.map((p, i) => (
          <TableRow key={i}>
            <TableRowItem width={320} align='middle'>
              <Text size={14} lineHeight={150}>
                {p.prompt}
              </Text>
            </TableRowItem>
            <TableRowItem width={88} align='middle'>
              <Text size={14}>{p.total_brands_mentioned}</Text>
            </TableRowItem>
            <TableRowItem align='middle'>
              <div className='flex flex-wrap gap-1.5'>
                {(p.mentioned_brands ?? []).map((mb, j) => (
                  <Badge
                    key={j}
                    size={10}
                    badgeType={
                      mb.brand === ownBrand ? BadgeType.SQUARE_PRIMARY : BadgeType.SQUARE_SECONDARY
                    }
                  >
                    {mb.brand} (#{mb.position})
                  </Badge>
                ))}
              </div>
            </TableRowItem>
          </TableRow>
        ))}
      </tbody>
    </table>
  </GeoSection>
)

export default ShareOfVoicePromptTable
